<template>
    <div class="markdown-body" v-html="previewText"></div>
</template>

<script>
    import marked from 'marked'

    export default {
        name: "MarkdownViewer",
        props: ['input'],
        computed:{
            previewText() {
                marked.setOptions({
                    renderer: new marked.Renderer(),
                    gfm: true,
                    tables: true,
                    breaks: true,
                    pedantic: false,
                    sanitize: true,
                    smartLists: true,
                    smartypants: false
                });
                return marked(this.input)
            }
        }
    }
</script>

<style src="../../node_modules/github-markdown-css/github-markdown.css"></style>
<style scoped>
</style>